// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__31c2n","errorLogs":"EditorFooter_errorLogs__1ishM"};